import HomeLayout from '@/app/home/views/components/HomeLayout.vue'
export default [
  {
    path: '/my-bid',
    component: HomeLayout,
    children: [
      // 查询页
      {
        path: 'list',
        component: () => import('@/app/myBid/index'),
        name: 'myBidList',
        meta: { title: 'module.my-bid.098674-0', icon: 'guide', whiteList:true}
      },
      // 物流投标页
      {
        path: 'logistics-action',
        component: () => import('@/app/myBid/logisticsBidAction'),
        name: 'logisticsBidAction',
        meta: { title: 'module.my-bid.098674-1', icon: 'guide', whiteList: true, isSupplierCodeRequired: true}
      },
      // 进出口投标页
      {
        path: 'imports-exports-action',
        component: () => import('@/app/myBid/importsExportsBidAction'),
        name: 'importsExportsBidAction',
        meta: { title: 'module.my-bid.098674-2', icon: 'guide', whiteList: true, isSupplierCodeRequired: true}
      },
    ]
  }

]

